<template>
  <b-modal hide-footer id="marksModal" :title="'Оценки по курсу ' + titleForModal"
           ref="marksModal" header-bg-variant="primary" size="lg"
           header-text-variant="light" @show="onShow">
    <div class="row">
      <ag-grid-vue style="height: 300px !important;"
                   class="ag-theme-material ag-grid-vue-marks col-md-12"
                   :columnDefs="columnDefs"
                   :gridOptions="gridOptions"
                   :rowData="rowData"
                   rowSelection="single"
                   @grid-ready="onGridReady"
                   @rowSelected="getSelectedRows"
                   @gridSizeChanged="onGridSizeChanged"
                   @column-resized="onColumnResized">
      </ag-grid-vue>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'MarksModal',
  components: {
    'ag-grid-vue': AgGridVue
  },
  computed: {
    ...mapGetters({
      content: 'education/getCourseContent',
      marks: 'education/getMarksForCourse'
    }),
    titleForModal() {
      if (this.content && this.content.contentObject) {
        return `"${this.content.contentObject.title}"`
      }
      return ''
    }
  },
  data() {
    return {
      rowData: null,
      columnDefs: [
        {
          headerName: 'Название теста',
          field: 'title',
          headerClass: 'table-header',
          width: 300,
          cellStyle: {
            'justify-content': 'left !important'
          }
        },
        {
          headerName: 'Оценка',
          field: 'mark',
          suppressSizeToFit: true,
          headerClass: 'table-header',
          width: 130
        }
      ],
      gridApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU
      }
    }
  },
  mounted() {
    if (this.$route.params.courseBookId !== undefined) { // TODO тренажер
      this.fetchMarksForCourse(this.$route.params.courseBookId).then(() => {
        this.rowData = this.marks
      })
    }
  },
  methods: {
    ...mapActions({
      fetchMarksForCourse: 'education/fetchMarksForCourse'
    }),
    onShow() {
      this.fetchMarksForCourse(this.$route.params.courseBookId).then(() => {
        this.rowData = this.marks
      })
    },
    onColumnResized() {
      this.gridApi.resetRowHeights()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    getSelectedRows() {},
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    }
  }
}
</script>

<style>
  .ag-grid-vue-marks
  .ag-row .ag-cell {
    padding-left: 25px !important;
    white-space: normal !important;
    text-align: left !important;
  }

  .table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    font-weight: bold;
    color: black;
  }

  .table-header:hover {
    background-color: #b0b6b7 !important;
  }

  .ag-grid-vue-marks .ag-header-viewport {
    background-color: #cdd3d4 !important;
  }

  .ag-grid-vue-marks .ag-center-cols-viewport {
    border-bottom: 1px solid #017ac3 !important;
  }

  .ag-grid-vue-marks {
    background-color: #f8fafc !important;
  }
</style>
